import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-copyright',
  templateUrl: './copyright.component.html',
  styleUrls: ['./copyright.component.scss'],
})
export class CopyrightComponent implements OnInit {
  public copyrightYear = new Date().getFullYear();

  constructor() {}

  ngOnInit(): void {}
}
